import * as Sentry from '@sentry/browser'
import { Integrations } from '@sentry/tracing'
import { App } from 'vue'

export default function init(app: App): void {
  Sentry.init({
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    dsn: window.SENTRY,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    release: `autowebinar@${window.VERSION}`,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
  })
  // eslint-disable-next-line no-param-reassign
  app.config.errorHandler = (err, vm, info) => {
    Sentry.setTag('info', info)
    Sentry.captureException(err)
    // eslint-disable-next-line no-console
    console.error(err)
  }
  window.addEventListener('error', (event) => {
    Sentry.captureException(event)
    // eslint-disable-next-line no-console
    console.error(event)
  })
  window.addEventListener('unhandledrejection', (event) => {
    Sentry.captureException(event)
    // eslint-disable-next-line no-console
    console.error(event)
  })
}
